import React, { Component } from 'react';
import { Row, Col, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { dispatchGamesList, setParticipation } from '../../actions/eventsAction';
import { connect } from 'react-redux';
import { formatDateDisplay, windowResize } from '../../utils';
import api from '../../api';

class BetSlots extends Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            participated: true
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.balance !== prevProps.balance) {
            if(typeof this.props.balance != 'undefined'){
                if (this.props.balance.length > 0) {
                    let gameType = this.props.gameType;
                    if (this.props.isMulti !== undefined) { gameType = 'multi-market'; }
    
                    let gamesList = [...this.props.gamesList[gameType]];
    
    
                    if(this.props.balance[0].participationBets){
                        if (Object.keys(this.props.balance[0].participationBets).length == 0) {
                            this.props.setParticipation(false);
                        }
                    }
    
                    for (const pkey in this.props.balance[0].participationBets) {
    
                        for (let i = 0; i < gamesList.length; i++) {
                            if (gamesList[i].id == pkey) {
                                gamesList[i].selectedballs.push(this.props.balance[0].participationBets[pkey]);
                            }
                        }
    
                    }
                    let wholeGamesList = Object.assign({}, this.props.gamesList);
                    wholeGamesList[gameType] = gamesList;
                    this.props.dispatchGamesList(wholeGamesList);
                }
            }

        }
        windowResize();
    }


    select(gameid, value) {
        if (this.props.participated) { return false; }
        let gameType = this.props.gameType;
        if (this.props.isMulti !== undefined) { gameType = 'multi-market'; }

        let gamesList = [...this.props.gamesList[gameType]];
        for (let i = 0; i < gamesList.length; i++) {
            if (gamesList[i].id == gameid) {
                if (gamesList[i].selectedballs.includes(value)) {
                    gamesList[i].selectedballs.splice(gamesList[i].selectedballs.indexOf(value), 1);
                } else {
                    gamesList[i].selectedballs = [];
                    gamesList[i].selectedballs.push(value);
                }
            }
        }
        let wholeGamesList = Object.assign({}, this.props.gamesList);

        wholeGamesList[gameType] = gamesList;
        this.props.dispatchGamesList(wholeGamesList);
    }

    render() {
        let games = this.props.gamesList;
        let market_names = {
            "oversunders": "Overs/Unders",
            "1x2": "1X2",
            "numberofgoals": "Number of goals"
        };

        if (this.props.isMulti !== undefined) {
            games = {};
            if (this.props.gamesList["multi-market"] !== undefined) {
                let markets = this.props.gamesList["multi-market"];
                for (let m = 0; m < markets.length; m++) {
                    let market_name = markets[m]['market_name'];
                    if (games[market_name] === undefined) { games[market_name] = []; }
                    games[market_name].push(markets[[m]]);
                }
            }
        }

        return (
            <div>
                {games[this.props.gameType].map((v, k) => {
                    return (
                        <Row key={k} className="no-gutters table-jackpot pl-1 pt-1">
                            <Col className=" tx-1 " lg="4" >
                                <b>{v.name} - {market_names[v.market_name]}</b>
                                {/* <div>{formatDateDisplay(v.match_date)}</div> */}
                            </Col>
                            <Col lg="8" >
                                <Row className="no-gutters " >
                                    {v.outcome.sort((a, b) => {
                                        return a.event_market_outcome_id < b.event_market_outcome_id ? -1 : a.event_market_outcome_id > b.event_market_outcome_id ? 1 : 0;
                                    }).map((b, i) => {
                                        return (
                                            <Col key={i} className={(this.props.gameType == "1x2" ? "" : " btn-col-nog ") + "betslot-btn ml-1"}>
                                                <Button onClick={() => { this.select(v.id, b.competition_event_market_id + "|" + b.event_market_outcome_id, b.odds) }} className={(this.props.gameType == "1x2" ? "" : " btn-jackpot-nog ") + " btn-jackpot w-100 " + (v.selectedballs.includes(b.competition_event_market_id + "|" + b.event_market_outcome_id) ? "" : "unselected")}>
                                                    <div>
                                                        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{b.name}</Tooltip>}>
                                                            <span className={(this.props.gameType == "1x2" ? "" : " btn-nog ") + (v.outcome.length <= 9 ? "" : " btn-w-100 ") + " float-left bj-1 "}>{b.name}</span>
                                                        </OverlayTrigger>
                                                        <span className={(this.props.gameType == "1x2" ? "" : " btn-nog ") + (v.outcome.length <= 9 ? "" : " btn-w-100 ") + " float-right bj-2 "}>{b.odds}</span>
                                                    </div>
                                                </Button>
                                            </Col>
                                        )
                                    })}
                                </Row>
                            </Col>
                        </Row>
                    )
                })}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        gamesList: state.eventsReducer.gamesList,
        participated: state.eventsReducer.participated,
        balance: state.balanceReducer.balance
    }
}

export default connect(mapStateToProps, { dispatchGamesList, setParticipation })(BetSlots);


// WEBPACK FOOTER //
// ./components/BetSlots/index.js